import { Routes } from '@angular/router'

import { DefaultApplicationPermissionsGuard } from '@flowx/designer/shared/guards/application-permissions.guards'
import { EditProcessInstanceVariablesGuard } from '@flowx/designer/shared/guards/workspaces-permissions.guards'
import { LayoutOptions } from '@flowx/designer/shared/types/layout.types'

import { ProcessInstanceDetailsComponent } from '../process/pages/process-instance-details/process-instance-details.component'

export const RuntimeActiveInstancesRoutes: Routes = [
  {
    path: '',
    data: { [LayoutOptions.HAS_SIDENAV]: true },
    loadComponent: () =>
      import('@flowx/designer/modules/process/pages/processes/processes.page').then(
        ({ ProcessesPageComponent }) => ProcessesPageComponent
      ),
    canActivate: [DefaultApplicationPermissionsGuard('process_instances_read')],
  },
  {
    path: ':uuid',
    component: ProcessInstanceDetailsComponent,
    canActivate: [
      DefaultApplicationPermissionsGuard('process_instances_read'),
      EditProcessInstanceVariablesGuard(),
    ],
  },
]
